// extracted by mini-css-extract-plugin
export default {"root":"GoWrnXE8atZlBMUK07AW","nav":"Rnxof1cZBl_93kISLca_","active":"jiHNVhdO2RMF9lFBhMlu","placeHolderShimmer":"lKsRtJMs5XaNHnWeVHBZ"};